/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Manage_Roles_TitleInputs */

const en_admin_users_manage_roles_title = /** @type {(inputs: Admin_Users_Manage_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage User Roles`)
};

const zh_admin_users_manage_roles_title = /** @type {(inputs: Admin_Users_Manage_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理用户角色`)
};

/**
* | output |
* | --- |
* | "Manage User Roles" |
*
* @param {Admin_Users_Manage_Roles_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_manage_roles_title = /** @type {((inputs?: Admin_Users_Manage_Roles_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Manage_Roles_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_manage_roles_title(inputs)
	return zh_admin_users_manage_roles_title(inputs)
});
export { admin_users_manage_roles_title as "admin.users.manage_roles_title" }